module.exports = __webpack_public_path__ + "media/images/hero/hero-bg4-bc32c1a41f48d7ae2bb8c5daac2c774a.png";